import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { formatPercent } from 'utils';
import { useTheme } from '@material-ui/styles';

interface Props {
  data: any;
  isAnimationActive?: boolean;
  bigLabels?: boolean;
  keys: any;
}

const StackedAssetAllocation = ({ data, keys }: Props) => {
  const theme = useTheme() as any;
  const [currentBar, setCurrentBar] = useState('');
  const isData = data && data.length > 0;
  const dataToRender = isData ? data : [];

  const CustomTooltip = ({ active, payload }: any) => {
    if (!active || !payload) return;
    for (const bar of payload) {
      if (bar.dataKey === currentBar) {
        return (
          <div
            style={{
              backgroundColor: '#fff',
              padding: '10px',
              borderRadius: '25px',
              boxShadow:
                '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)'
            }}
          >
            {bar.name} : {formatPercent(bar.value)}
          </div>
        );
      }
    }
    return null;
  };

  const chartHeight = Math.max(data.length, 1.75) * 100;

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart
        layout="vertical"
        data={dataToRender}
        margin={{ top: 20, right: 30, left: 35, bottom: 10 }}
      >
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis
          type="number"
          domain={[0, 100]}
          tickFormatter={value => `${Math.floor(value).toString()}%`}
        />
        <YAxis
          type="category"
          dataKey="name"
          width={300}
          tick={{ fontSize: '.9rem' }}
          tickLine={false}
          tickMargin={20}
        />
        <Tooltip wrapperStyle={{ zIndex: 9 }} content={CustomTooltip} />
        <Legend align="center" iconType="circle" />
        {keys.map((key: any, index: number) => (
          <Bar
            key={index}
            dataKey={key}
            onMouseOver={() => setCurrentBar(key)}
            stackId="a"
            fill={theme.palette.baseColors.charts['asset-allocation'][index]}
            style={{ stroke: '#fff', strokeWidth: 4 }}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default StackedAssetAllocation;
